import { PlacementErrorType } from '@frontend/sports/types/betslip';

import { UserError } from './user-error';

export class BlockedCoolOff extends UserError {
    constructor(date: string | Date | undefined) {
        super();
        if (date) {
            this.coolOffDateUtc = date instanceof Date ? date : new Date(date);
        }
        this.type = PlacementErrorType.BlockedCoolOff;
    }

    coolOffDateUtc: Date | null = null;
}
